import { useEffect, useState } from 'react'
import { RDS_VM_COUNT_MAX, RDS_VM_COUNT_MIN, clampRdsVmCount } from '@/data/sizeCatalog'
import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { TextField } from './TextField'

/**
 * "How many RDS VMs do you need?" for a Dedicated RDS server of a product that uses the pool tiers (RdsServerSection decides when it is shown).
 * The answer, a whole number from 1 to 8, is the only place the number is entered: the names, the free IPs the subnet needs, the vCPU quota
 * that is checked and the request all follow it. What is typed may be empty for a moment while the user edits, so it is kept here as text;
 * the store only ever holds a valid count (the store moves anything else into the range), and the box shows it again when it is left.
 */
export function RdsVmCountField() {
  const count = useInfrastructureWizard((s) => s.rdsServer.count)
  const setCount = useInfrastructureWizard((s) => s.setRdsVmCount)
  const [text, setText] = useState(String(count))

  // Follow the store when the count changes from outside (a reset, or the server's choice changing).
  useEffect(() => {
    setText(String(count))
  }, [count])

  const change = (raw: string) => {
    if (raw.trim() === '') {
      setText(raw)
      return
    }
    const next = clampRdsVmCount(Number(raw))
    setCount(next)
    setText(String(next))
  }

  return (
    <div data-testid="rds-vm-count-field">
      <TextField
        id="rds-vm-count"
        label="How many RDS VMs do you need?"
        required
        type="number"
        min={RDS_VM_COUNT_MIN}
        max={RDS_VM_COUNT_MAX}
        value={text}
        onChange={change}
        onBlur={() => setText(String(count))}
        hint="They are created together, in one run, after the whole set has been checked."
      />
    </div>
  )
}
